module.exports = __webpack_public_path__ + "static/media/galPic6.cb25c07b.JPG";